import { UPDATE_MODAL } from "./modal.constants";

export const updateModal = (payload) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_MODAL, payload });
  };
};
